import { X } from "lucide-react";
import { useEffect } from "react";

const comparisonRows = [
  ["Preis", "price"],
  ["Finanzierung", "monthly"],
  ["Erstzulassung", "first_registration"],
  ["Laufleistung", "mileage"],
  ["Leistung", "power"],
  ["Kraftstoff", "fuel"],
  ["Getriebe", "gearbox"],
  ["Hubraum", "displacement"],
  ["Schadstoffklasse", "emission_class"],
  ["Außenfarbe", "color"],
  ["Türen", "doors"],
  ["Sitzplätze", "seats"],
  ["Vorbesitzer", "previous_owners"],
  ["Kategorie", "category"],
  ["Zustand", "condition"]
];

export default function VehicleCompareModal({ vehicles, onClose, onRemove }) {
  useEffect(() => {
    const closeOnEscape = (event) => event.key === "Escape" && onClose();
    document.addEventListener("keydown", closeOnEscape);
    document.body.classList.add("modal-open");
    return () => {
      document.removeEventListener("keydown", closeOnEscape);
      document.body.classList.remove("modal-open");
    };
  }, [onClose]);

  return (
    <div className="modal-backdrop" role="presentation" onMouseDown={(event) => event.target === event.currentTarget && onClose()}>
      <div className="compare-modal" role="dialog" aria-modal="true" aria-labelledby="compare-modal-title" data-testid="vehicle-compare-modal">
        <div className="compare-modal-header"><div><span className="section-kicker">BESTAND · DIREKTVERGLEICH</span><h2 id="compare-modal-title">Zwei Fahrzeuge.<br /><em>Eine Entscheidung.</em></h2></div><button className="modal-close" type="button" aria-label="Vergleich schließen" onClick={onClose} data-testid="vehicle-compare-close-button"><X size={20} strokeWidth={1.5} /></button></div>
        <div className="compare-vehicles">{vehicles.map((vehicle) => <div className="compare-vehicle" key={vehicle.id} data-testid={`compare-vehicle-${vehicle.id}`}><img src={vehicle.image} alt={`${vehicle.brand} ${vehicle.title}`} /><div><span className="mono-label">{vehicle.brand} · {vehicle.year}</span><h3>{vehicle.title}</h3></div><button className="compare-remove" type="button" onClick={() => onRemove(vehicle.id)} data-testid={`compare-remove-${vehicle.id}`}>Entfernen</button></div>)}</div>
        <div className="compare-table" role="table" aria-label="Fahrzeugvergleich">{comparisonRows.map(([label, key]) => <div className="compare-row" role="row" key={key} data-testid={`compare-row-${key}`}><span role="rowheader">{label}</span>{vehicles.map((vehicle) => <strong role="cell" key={`${vehicle.id}-${key}`}>{vehicle[key] || "Nicht angegeben"}</strong>)}</div>)}</div>
        <div className="compare-modal-footer"><span>Angaben aus dem aktuellen Händlerbestand von A+B Automobile.</span><span>Besichtigung und Anfrage direkt bei Mosel Cars</span></div>
      </div>
    </div>
  );
}
